import { levelPctForFluency } from "@bindery/shared/contracts/decay";
import { TileFront } from "../n5/tile-front";
import type { LaidAtlasEntry } from "./types";

interface Props {
  entry: LaidAtlasEntry;
  rank: number;
}

export function AtlasTile({ entry, rank }: Props) {
  const density: "tiny" | "compact" | "full" =
    entry.w * entry.h < 1.5
      ? "tiny"
      : entry.w * entry.h < 5
        ? "compact"
        : "full";

  return (
    <div
      className="n5-tile border-rule absolute overflow-hidden border"
      data-readonly="true"
      data-density={density}
      aria-label={`${entry.display} — ${entry.gloss}`}
      style={{
        left: `${entry.x}%`,
        top: `${entry.y}%`,
        width: `${entry.w}%`,
        height: `${entry.h}%`,
        ["--level-pct" as string]: `${levelPctForFluency(entry.decayed_level)}%`,
      }}
    >
      <TileFront entry={entry} rank={rank} density={density} />
    </div>
  );
}
